import { CONTACT } from '../config/contact';
import { track } from '../lib/analytics';
import { OPEN_CONSENT_EVENT } from '../components/ConsentBanner';

export default function Footer() {
  return (
    <footer style={{ background: '#201F1D', padding: 'clamp(48px,7vw,72px) clamp(20px,6vw,72px)' }}>
      <div style={{ maxWidth: 1160, margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '36px 64px', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <svg viewBox="0 0 96 96" width={48} height={48} role="img" aria-label="GrihaTEK logo" style={{ flex: 'none', display: 'block' }}>
            <path d="M10 46 L48 10 L86 46" fill="none" stroke="#FAF9F7" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 40 L18 86 L78 86 L78 40" fill="none" stroke="#FAF9F7" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" />
            <circle cx={48} cy={66} r={4.5} fill="#C98F3D" />
            <path d="M40.93 58.93 A10 10 0 0 1 55.07 58.93" style={{ animation: 'gt-arc 2.4s ease-in-out 0s infinite' }} fill="none" stroke="#C98F3D" strokeWidth={4.5} strokeLinecap="round" />
            <path d="M35.98 53.98 A17 17 0 0 1 60.02 53.98" style={{ animation: 'gt-arc 2.4s ease-in-out .25s infinite' }} fill="none" stroke="#C98F3D" strokeWidth={4.5} strokeLinecap="round" />
            <path d="M31.03 49.03 A24 24 0 0 1 64.97 49.03" style={{ animation: 'gt-arc 2.4s ease-in-out .5s infinite' }} fill="none" stroke="#C98F3D" strokeWidth={4.5} strokeLinecap="round" />
          </svg>
          <div>
            <div style={{ fontSize: 21, fontWeight: 600, letterSpacing: '-0.015em', lineHeight: 1, color: '#FAF9F7' }}>Griha<span style={{ color: '#C98F3D' }}>TEK</span></div>
            <p style={{ margin: '4px 0 0', fontSize: 13, fontStyle: 'italic', color: '#C9C4BB' }}>Intelligence, indoors.</p>
            <p style={{ margin: '4px 0 0', fontSize: 12.5, color: '#B9B4AC' }}>Smart homes, built and installed in Bengal.</p>
          </div>
        </div>
        <div style={{ fontSize: 15, lineHeight: 2.1 }}>
          <a
            href={CONTACT.phoneHref}
            onClick={() => track('phone_click', { element_location: 'footer' })}
            style={{ display: 'block', color: '#FAF9F7', textDecoration: 'none', fontWeight: 600 }}
          >
            {CONTACT.phoneDisplay}
          </a>
          <a
            href={`mailto:${CONTACT.email}`}
            onClick={() => track('email_click', { element_location: 'footer' })}
            style={{ display: 'block', color: '#C98F3D', textDecoration: 'none' }}
          >
            {CONTACT.email}
          </a>
        </div>
        <address style={{ fontStyle: 'normal', fontSize: 13, lineHeight: 1.8, color: '#B9B4AC' }}>
          GRIHATEK IT SOLUTIONS PRIVATE LIMITED<br />
          CIN U62091WR2026PTC295515<br />
          {CONTACT.addressLine1}<br />
          {CONTACT.addressLine2}
        </address>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 18px', fontSize: 13 }}>
          <a href="/guides" style={{ color: '#B9B4AC', textDecoration: 'underline' }}>Guides</a>
          <a href="/privacy-policy" style={{ color: '#B9B4AC', textDecoration: 'underline' }}>Privacy Policy</a>
          <a href="/terms-of-service" style={{ color: '#B9B4AC', textDecoration: 'underline' }}>Terms of Service</a>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent(OPEN_CONSENT_EVENT))}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              color: '#B9B4AC',
              textDecoration: 'underline',
              fontSize: 'inherit',
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Cookie preferences
          </button>
        </div>
        <p style={{ flexBasis: '100%', margin: 0, paddingTop: 20, borderTop: '1px solid rgba(250,249,247,.14)', fontSize: 12.5, color: '#A09C94' }}>Last updated: <time dateTime="2026-08-07">7 August 2026</time></p>
        <p style={{ flexBasis: '100%', margin: 0, fontSize: 11.5, color: '#7A766E' }}>
          This site is protected by reCAPTCHA and the Google{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#7A766E', textDecoration: 'underline' }}>Privacy Policy</a>{' '}
          and{' '}
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: '#7A766E', textDecoration: 'underline' }}>Terms of Service</a>{' '}
          apply.
        </p>
      </div>
    </footer>
  );
}
